export default __webpack_public_path__ + "4bd707ce9ec4f03666deb0dc26b654f4.jpg";